<template>
	<div class="omapi-campaign-table__filters flex">
		<div class="omapi-campaign-table__filters-date">
			<!-- Date Range Filter -->
			<select v-model="dateRange">
				<option value="">Filter by Date</option>
				<option value="all">All Time</option>
				<option value="7">Last 7 Days</option>
				<option value="30">Last 30 Days</option>
			</select>
			<core-button size="large" :disabled="!dateRange" @click.prevent="handleDateFilter">Apply</core-button>
		</div>
		<div class="omapi-campaign-table__filters-columns">
			<!-- TODO: Make these work. -->
			<!-- <select v-model="filter" @change="resetFilterValue">
				<option value="status">Status</option>
				<option value="campaignType">Type</option>
			</select> -->
			<select v-model="filterValue">
				<option value="">{{ defaultOption }}</option>
				<option v-for="option in options" :key="option.value" :value="option.value">
					{{ option.label }}
				</option>
			</select>
			<core-button size="large" :disabled="!canFilter" @click.prevent="handleFilter">Filter</core-button>
		</div>
		<core-button v-show="canResetFilters" size="large" @click.prevent="clickReset">Clear</core-button>
	</div>
</template>

<script>
import flatMap from 'lodash/flatMap';
import sub from 'date-fns/sub';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { dates } from '@/utils';

export default {
	data() {
		return {
			dateRange: '',
			filter: 'campaignType',
			filterValue: '',
			statusFilter: [
				{
					value: 'active',
					label: 'Published',
				},
				{
					value: 'pause',
					label: 'Draft',
				},
			],
		};
	},
	computed: {
		...mapState('templates', ['types']),
		...mapGetters('campaigns', ['canResetFilters']),
		defaultOption() {
			return 'status' === this.filter ? 'All Statuses' : 'All Types';
		},
		campaignTypeFilter() {
			// Convert campaign types to needed format for the filter.
			const types = flatMap(this.types, (type, value) => {
				return 'gamified' === value ? false : { value, label: type.name };
			}).filter((t) => !!t);

			return types;
		},
		options() {
			return this[`${this.filter}Filter`];
		},
		canFilter() {
			return this.filter && this.filterValue;
		},
	},
	mounted() {
		this.$bus.$on('resetAllCampaignFilters', this.doReset);
	},
	beforeDestroy() {
		this.$bus.$off('resetAllCampaignFilters', this.doReset);
	},
	methods: {
		...mapMutations('campaigns', ['setFilterValues']),
		...mapActions('campaigns', ['resetFilters', 'refreshDashboard']),
		/**
		 * Do Date Filter
		 *
		 * @returns {void}
		 */
		handleDateFilter() {
			if ('all' === this.dateRange || !this.dateRange) {
				return this.resetFilters({ keys: ['starts', 'ends'] });
			}

			this.setFilterValues({
				starts: dates.timestamp(sub(Date.now(), { days: this.dateRange })),
				ends: dates.timestamp(), // Current Date
			});

			this.refreshDashboard().catch(() => {});
		},
		/**
		 * Filter Campaigns
		 *
		 * @returns {void}
		 */
		handleFilter() {
			if ('all' === this.filterValue || !this.filterValue) {
				return this.resetFilters({ keys: ['status', 'campaignType'] });
			}

			this.setFilterValues({ [this.filter]: this.filterValue });
			this.refreshDashboard().catch(() => {});
		},
		clickReset() {
			return this.resetFilters();
		},
		doReset() {
			this.dateRange = '';
			this.filter = 'campaignType';
			this.filterValue = '';
		},
		// Changes the second filter dropdown to empty (i.e. 'Select Filter' when the first dropdown is changed)
		resetFilterValue() {
			this.filterValue = '';
		},
	},
};
</script>
<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen {
	.omapi-campaign-table__filters {
		.omapi-button {
			margin-left: 6px;
			margin-right: 0;
		}
	}
}
</style>
